<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de tempo de atendimento">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/relatorio-tempo-atendimento/List'

export default {
    components: { List },
}
</script>